import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik"; import React, { useState } from "react"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap"; import { ExportToExcelButton, generatePDF, GetDetails, LabelHeader, ModuleHeader } from "../../utils/commonFunctions"; import { store } from "../../../App";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import jsPDF from "jspdf";


const SalaryJVReport = () => {
    const [monthslist, setMonthslist] = useState([]); const [yearslist, setYearslist] = useState([]); const [tableEnable, settableEnable] = useState(false); const [values, setValues] = useState([]);

    const formik = useFormik({
        initialValues: { year: "", month: "", jv_type: "", },
        validate: (values) => {
            const errors = {};
            if (!values.year) { errors.year = "select year"; }
            if (!values.month) { errors.month = "select month"; }
            if (!values.jv_type) { errors.jv_type = "select jv type"; }
            return errors;
        },
        onSubmit: () => {
            store.dispatch({ type: "SHOW_SPINNER" });
            let params = { year: formik.values.year, month: formik.values.month, jv_type: formik.values.jv_type };
            HousingService.GetSalary_OnlineJV_Report_Values(params).then((res) => {
                if (res && res.data && res.data?.length > 0) { setValues(res.data); }
                else { setValues([]); }
            }).catch((error) => {
                console.error("Error fetching data:", error);
            }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
                settableEnable(true);
            })
        }
    });
    React.useEffect(() => {
        HousingService.Months_Drop_Down().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    if (item !== null) {
                        return (<option key={i} value={item.month_id}> {item.month_name} </option>);
                    }
                });
                setMonthslist(options);
            }
        });
    }, []);
    React.useEffect(() => {
        HousingService.years_Drop_Down().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    if (item !== null) {
                        return (<option key={i} value={item.year}> {item.year} </option>);
                    }
                });
                setYearslist(options);
            }
        });
    }, []);


    function SalaryJVPDF() {
        const pageWidth = 210; const pageHeight = 297; const imgPath = "/img/APSHCL_logo.png"; const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });  const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)"; const headingText3 = `Salary JV's Report`; const headingText4 = "  Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007"; const fontSize = 10; doc.setFont("times new roman"); doc.setFontSize(fontSize); const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor; const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor; const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor; const tableYStart = 45; doc.setFontSize(fontSize); const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2; doc.text(headingText2, xCoordinate2, 10); const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2; const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2; doc.text(headingText3, xCoordinate3, 40); doc.text(headingText4, xCoordinate4, 20);
        doc.addImage(imgPath, "PNG", 10, 10, 30, 30); doc.autoTable({ html: "#my-table", theme: "striped", tableWidth: "auto", columnStyles: { 3: { cellWidth: "wrap" }, }, startY: tableYStart, margin: { top: 5, right: 10, bottom: 5, left: 10 }, styles: { fontSize: 8, }, columnWidth: { 0: 20, 1: 30, 2: 40 }, });
        doc.save("SalaryJVReport.pdf");
    }
    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Salary JV's Report" />
            <OFMSUI.Container className="outer-page-content-container " fluid style={{ width: "90%" }} >
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <OFMSUI.Row>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <LabelHeader title="Year" />
                                <Field name="year" component="select" onChange={(e) => formik.handleChange(e)} className={formik.touched.year && formik.errors.year ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {yearslist} </Field>
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                <LabelHeader title="Month" />
                                <Field name="month" component="select" onChange={(e) => formik.handleChange(e)} className={formik.touched.month && formik.errors.month ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {monthslist} </Field>
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <LabelHeader title="Type" />
                                <Field name="jv_type" component="select" onChange={(e) => formik.handleChange(e)} className={formik.touched.jv_type && formik.errors.jv_type ? "form-control is-invalid" : "form-control"} > <option value="">Select</option>
                                    <option value="sjv">Salary Journal Vouchers</option>
                                </Field>
                            </OFMSUI.Col>
                            <GetDetails />
                        </OFMSUI.Row>

                        {tableEnable && (
                            <>
                                <OFMSUI.Row>
                                    <OFMSUI.Col xs={12} sm={12} md={9} lg={12} xl={12} xxl={12} className=" mb-2 float-end" >
                                        <button type="button" className="btn btn-danger btn-sm"
                                            onClick={SalaryJVPDF}
                                            style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                        <ExportToExcelButton tableId="my-table" filename="SalaryAndOnlineJVReport" sheet="tablexls" buttonText="Excel" />
                                    </OFMSUI.Col>
                                </OFMSUI.Row>
                                <Table striped bordered hover id="my-table" fluid>
                                    <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                                        <tr className="table_countshead text-center">
                                            <th>S No.</th>
                                            <th className="text-left">District</th>
                                            <th>Sal-Reg(17)</th>
                                            <th>Sal-OS(18)</th>
                                            <th>Sal-NMR(19)</th>
                                            <th>Sal-SC(20)</th>
                                            <th>Sal-EPF(21)</th>
                                            <th>Supp-Reg(22)</th>
                                            <th>Supp-OS(23)</th>
                                            <th>Supp-NMR(24)</th>
                                            <th>Supp-SC(25)</th>
                                            <th>Supp-EPF(26)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {values.map((row, index) => (
                                            <tr key={index} className="text-right">
                                                <td className="text-center" >{index + 1}</td>
                                                <td className="text-left">{row.name}</td>
                                                <td>{row.reg17}</td>
                                                <td>{row.os18}</td>
                                                <td>{row.nmr19}</td>
                                                <td>{row.sc20}</td>
                                                <td>{row.epf21}</td>
                                                <td>{row.suppreg22}</td>
                                                <td>{row.suppos23}</td>
                                                <td>{row.suppnmr24}</td>
                                                <td>{row.suppsc25}</td>
                                                <td>{row.suppepf26}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="table_countshead text-right" >
                                            <td colSpan="2" className="text-center">Total Amount in Rs/-</td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.reg17) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.os18) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.nmr19) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.sc20) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.epf21) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.suppreg22) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.suppos23) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.suppnmr24) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.suppsc25) || 0), 0)} </td>
                                            <td> {values.reduce((sum, row) => sum + (parseFloat(row.suppepf26) || 0), 0)} </td>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </>


                        )}
                    </Form>
                </FormikProvider>
            </OFMSUI.Container>
        </>
    );
};
export default SalaryJVReport;
